import { computed, defineComponent, onBeforeUnmount, watch } from 'vue';
import { CheckerService } from '@/services/device/checker.service';
import { declareProviders, useService } from '@kaokei/use-vue-service';
import { UserService } from '@/services/user.service';
import StepOne from './components/stepOne.vue';
import StepTwo from './components/stepTwo.vue';
import StepThree from './components/stepThree.vue';
import ModalNoDevice from './components/modal/NoDevice.vue';
export default defineComponent({
  components: {
    StepOne: StepOne,
    StepTwo: StepTwo,
    StepThree: StepThree,
    ModalNoDevice: ModalNoDevice
  },
  setup: function () {
    declareProviders([CheckerService]);
    var checkerService = useService(CheckerService);
    var userService = useService(UserService);
    var steps = computed(function () {
      return checkerService.checkStep;
    });
    var currentStepItem = computed(function () {
      return checkerService.checkStep[checkerService.currentStepIndex];
    });
    var handleStep = function (index) {
      checkerService.goStep(index, true);
    };
    onBeforeUnmount(function () {
      checkerService.uninstall();
    });
    watch(function () {
      return checkerService.deviceActiveStatus;
    }, function (status) {
      if (status === 'inactive') {
        checkerService.NoDeviceVisible = true;
        checkerService.DeviceState.hasClickChecked = false;
      }
    });
    watch(function () {
      return userService.user;
    }, function (user) {
      if (user && user.userId) {
        // 初始化获取数据
        checkerService.initPage();
      }
    }, {
      immediate: true
    });
    return {
      steps: steps,
      currentStepItem: currentStepItem,
      handleStep: handleStep,
      checkerService: checkerService
    };
  }
});